<template>
    <div class="page-proven-benefits">
        <div class="jumbo-wrapper proven-benefits">
            <div class="jumbo-main">
                <div class="jumbo-content">
                    <p class="t15">PROVEN BENEFITS</p>
                    <h2 class="t42">
                        PERSONALIZE THE
                        <br/>
                        FUNDRAISING EXPERIENCE
                    </h2>
                    <p class="t20">Heartfelt messages will be showcased for generations.</p>
                </div>
            </div>
        </div>
        <div class="box-content">
            <div class="box-content-inner">
                <div class="row engraved-icons">
                    <div class="col-sm-6 col-xs-12 col-md-4 text-center">
                        <div class="icon-box">
                            <img src="images/Proven-Benefits/engageicon.png" alt="">
                        </div>
                        <h2>STRENGTHEN CONNECTIONS</h2>
                        <p>Showcase your community's support</p>
                    </div>
                    <div class="col-sm-6 col-xs-12 col-md-4 text-center">
                        <div class="icon-box">
                            <img src="images/Proven-Benefits/raisefundsicon.png" alt="">
                        </div>
                        <h2>RAISE FUNDS</h2>
                        <p>Meet key fundraising objectives</p>
                    </div>
                    <div class="col-sm-6 col-xs-12 col-md-4 text-center">
                        <div class="icon-box">
                            <img src="images/Proven-Benefits/activateicon.png" alt="">
                        </div>
                        <h2>BEAUTIFY ANY SPACE</h2>
                        <p>Add visual impact that lasts</p>
                    </div>
                </div>

                <hr class="frl-hr"/>

                <div class="body-area">
                    <div class="body-area-left">
                        <h6 class="body-area-headline">
                            A FUNDRAISING CONCEPT
                            THAT GIVES DONORS AT ALL
                            LEVELS A TANGIBLE WAY TO PUT
                            THEIR NAME ON A PROJECT.
                        </h6>
                        <p>
                            Offer your donors a brick or tile they can
                            customize to be placed at your facility or
                            selected location. The permanent showcase
                            stregthens the connection with your donors -
                            past, present, and future.
                        </p>
                    </div>
                    <div class="body-area-right">
                        <img width="443" height="362" class="img-responsive" src="images/Proven-Benefits/engravedbrickprojects01.png" alt="">
                    </div>
                </div>

                <hr class="frl-hr"/>

                <div class="body-area">
                    <div class="body-area-left">
                        <img width="443" height="362" class="img-responsive" src="images/Proven-Benefits/engravedbrickprojects02.png" alt="">
                    </div>
                    <div class="body-area-right">
                        <h6 class="body-area-headline">
                            NOW IS A GREAT TIME TO<br/>
                            START YOUR ENGRAVED<br/>
                            BRICK FUNDRAISER.
                        </h6>
                        <p>
                            Whether you have a specific fundraising goal,
                            want to celebrate a historic moment or
                            anniversary, or just want to recognize donors,
                            it’s always a good time!
                        </p>
                        <ul class="body-area-list">
                            <li><span>New Facility Construction or Renovations</span></li>
                            <li><span>Activate Underutilized Areas</span></li>
                            <li><span>Create a Gathering Space</span></li>
                            <li><span>Commemorate Town History or Anniversary</span></li>
                            <li><span>Honor Military Veterans</span></li>
                            <li><span>Dedicate a Project or Space</span></li>
                        </ul>
                    </div>
                </div>

                <hr class="frl-hr"/>

                <div class="body-area">
                    <div class="body-area-left">
                        <h6 class="body-area-headline">
                            TRANSFORM ANY LOCATION<br/>
                            INTO A DESTINATION,<br/>
                            SHOWCASING PERSONAL<br/>
                            MESSAGES FROM DONORS.
                        </h6>
                        <p>
                            Showcase a central location or an underutilized
                            space. Engraved bricks will create a space for
                            your donors and others to gather, connect,
                            photograph &amp; enjoy!
                        </p>
                        <ul class="body-area-list list2col">
                            <li><span>Entrances</span></li>
                            <li><span>Sidewalks</span></li>
                            <li><span>Walkways</span></li>
                            <li><span>Gardens</span></li>
                            <li><span>Plazas</span></li>
                            <li><span>Indoor Walls</span></li>
                            <li><span>Outdoor Walls</span></li>
                            <li><span>Underutilized Areas</span></li>
                        </ul>
                    </div>
                    <div class="body-area-right">
                        <img width="443" height="362" class="img-responsive" src="images/Proven-Benefits/engravedbrickprojects03.png" alt="">
                    </div>
                </div>

                <hr class="frl-hr"/>

                <testimonials-carousel addclass="content-slider">
                    <div class="carousel-inner" role="listbox">
                        <div class="quote-slider-item item active">
                            <div class="content-slider-item">
                                <div class="slider-text">
                                    <p class="slider-header">
                                        Engraved Brick Projects:
                                        <br/>
                                        From Concept to Completion
                                    </p>
                                    <p class="slider-paragraph">
                                        Centennial Park Monument
                                        <br/>
                                        McCall, ID
                                    </p>
                                </div>
                                <div class="slider-image">
                                    <img src="images/Proven-Benefits/rotatingprojects01.png" class="img-responsive" alt=""/>
                                </div>
                            </div>
                        </div>
                        <div class="quote-slider-item item">
                            <div class="content-slider-item">
                                <div class="slider-text">
                                    <p class="slider-header">
                                        Engraved Brick Projects:
                                        <br/>
                                        From Concept to Completion
                                    </p>
                                    <p class="slider-paragraph">
                                        The Grove Plaza
                                        <br/>
                                        Boise, ID
                                    </p>
                                </div>
                                <div class="slider-image">
                                    <img src="images/Proven-Benefits/rotatingprojects02.png" class="img-responsive" alt=""/>
                                </div>
                            </div>
                        </div>
                        <div class="quote-slider-item item">
                            <div class="content-slider-item">
                                <div class="slider-text">
                                    <p class="slider-header">
                                        Engraved Brick Projects:
                                        <br/>
                                        From Concept to Completion
                                    </p>
                                    <p class="slider-paragraph">
                                        Portsmouth Veterans Memorial
                                        <br/>
                                        Portsmouth, NH
                                    </p>
                                </div>
                                <div class="slider-image">
                                    <img src="images/Proven-Benefits/rotatingprojects03.png" class="img-responsive" alt=""/>
                                </div>
                            </div>
                        </div>
                    </div>
                </testimonials-carousel>
            </div>
        </div>
    </div>
</template>

<script type="text/jsx">
    import Testimonials from "./Testimonials";
    export default {
        name: 'proven-benefits',
        components: {
            'testimonials-carousel': Testimonials
        },
        metaInfo: {
            title: 'Proven Benefits',
            meta: [
                {
                    vmid: 'description',
                    name: 'description',
                    content: ''
                }
            ]
        }
    }
</script>



// WEBPACK FOOTER //
// ProvenBenefits.vue?1bf748ff